import { RespResumeOtherAttachment } from "./ItemResume"
import moment from "moment"
import { uuid } from "./ItemTools"
import { ReqCustomerPositionList, MarginCalculationType_Fixed, MarginCalculationType_RealPayRatio, MarginCalculationType_BaseSalaryRatio, InsuranceBurdenType_Company } from "./ItemCustomerPosition"

export const CONTRACTOR_ATTENDANCE_STATUS_EDIT = 1
export const CONTRACTOR_ATTENDANCE_STATUS_FINISH = 2
export const CONTRACTOR_ATTENDANCE_STATUS_OBSOLETE = 3
export const CONTRACTOR_ATTENDANCE_STATUS_ALL = 0

export const CONTRACTOR_ATTENDANCE_STATUS_EDIT_STRING = "編輯中"
export const CONTRACTOR_ATTENDANCE_STATUS_FINISH_STRING = "已完成"
export const CONTRACTOR_ATTENDANCE_STATUS_OBSOLETE_STRING = "已作廢"
export const CONTRACTOR_ATTENDANCE_STATUS_ALL_STRING = "全部"


export const contractorAttendanceStatusAttr = [
    { "val": CONTRACTOR_ATTENDANCE_STATUS_EDIT, "name": CONTRACTOR_ATTENDANCE_STATUS_EDIT_STRING },
    { "val": CONTRACTOR_ATTENDANCE_STATUS_FINISH, "name": CONTRACTOR_ATTENDANCE_STATUS_FINISH_STRING },
    { "val": CONTRACTOR_ATTENDANCE_STATUS_OBSOLETE, "name": CONTRACTOR_ATTENDANCE_STATUS_OBSOLETE_STRING },
    { "val": CONTRACTOR_ATTENDANCE_STATUS_ALL, "name": CONTRACTOR_ATTENDANCE_STATUS_ALL_STRING },
]

export const contractorAttendanceStatusAttr_Edit = [
    { "val": CONTRACTOR_ATTENDANCE_STATUS_EDIT, "name": CONTRACTOR_ATTENDANCE_STATUS_EDIT_STRING },
    { "val": CONTRACTOR_ATTENDANCE_STATUS_FINISH, "name": CONTRACTOR_ATTENDANCE_STATUS_FINISH_STRING },
    { "val": CONTRACTOR_ATTENDANCE_STATUS_OBSOLETE, "name": CONTRACTOR_ATTENDANCE_STATUS_OBSOLETE_STRING }
]

export const contractorAttendanceStatusAttr_Register = [
    { "val": CONTRACTOR_ATTENDANCE_STATUS_EDIT, "name": CONTRACTOR_ATTENDANCE_STATUS_EDIT_STRING },
    { "val": CONTRACTOR_ATTENDANCE_STATUS_FINISH, "name": CONTRACTOR_ATTENDANCE_STATUS_FINISH_STRING }
]

export const DailyWageMonthly_Fixed = 0
export const DailyWageMonthly_Real = 1
export const DailyWageMonthly_Fixed_String = "不分大小月"
export const DailyWageMonthly_Real_String = "按照當月實際天數"

export const DailyWageMonthlyAttr = [
    { "val": DailyWageMonthly_Fixed, "name": DailyWageMonthly_Fixed_String },
    { "val": DailyWageMonthly_Real, "name": DailyWageMonthly_Real_String },
]

export const getContractorAttendanceStatusString = (status) => {
    switch (status) {
        case CONTRACTOR_ATTENDANCE_STATUS_EDIT:
            return CONTRACTOR_ATTENDANCE_STATUS_EDIT_STRING
        case CONTRACTOR_ATTENDANCE_STATUS_FINISH:
            return CONTRACTOR_ATTENDANCE_STATUS_FINISH_STRING
        case CONTRACTOR_ATTENDANCE_STATUS_OBSOLETE:
            return CONTRACTOR_ATTENDANCE_STATUS_OBSOLETE_STRING
        default:
            return ""
    }
}

export class ReqContractorAttendanceList {
    constructor({ companyId, start, limit, contractorAttendanceSOPName, contractorAttendanceSOPStatus }) {
        this.companyId = companyId
        this.start = start
        this.limit = limit
        this.contractorAttendanceSOPName = contractorAttendanceSOPName || ""
        this.contractorAttendanceSOPStatus = contractorAttendanceSOPStatus || CONTRACTOR_ATTENDANCE_STATUS_EDIT
    }

    fromJson(jsonData) {
        if (jsonData === undefined)
            return
        this.companyId = jsonData.companyId || ""
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
        this.contractorAttendanceSOPName = jsonData.contractorAttendanceSOPName || ""
        this.contractorAttendanceSOPStatus = jsonData.contractorAttendanceSOPStatus || CONTRACTOR_ATTENDANCE_STATUS_EDIT
    }
}

export class ReqContractorAttendanceSOPList {
    constructor({ companyId, start, limit, companyName }) {
        this.companyId = companyId
        this.start = start
        this.limit = limit
        this.companyName = companyName
    }

    fromJson(jsonData) {
        if (this.companyId === undefined)
            this.companyId = jsonData.companyId
        this.start = jsonData.start
        this.limit = jsonData.limit
        this.companyName = jsonData.companyName || ""
    }
}

//計薪方式/上工人數
export class ReqContractorAttendanceSOPCount {
    constructor({ companyId, customerContractId, startDate, endDate }) {
        this.customerContractId = customerContractId
        this.companyId = companyId
        this.startDate = startDate
        this.endDate = endDate
    }

    fromJson(jsonData) {
        this.companyId = jsonData.companyId || ""
        this.customerContractId = jsonData.customerContractId || ""
        this.startDate = jsonData.startDate || ""
        this.endDate = jsonData.endDate || ""
    }
}

export class ReqContractorAttendanceDetail {
    constructor({ companyId, contractorAttendanceId }) {
        this.companyId = companyId
        this.contractorAttendanceId = contractorAttendanceId
    }

    fromJson(jsonData) {
        this.companyId = jsonData.companyId || ""
        this.contractorAttendanceId = jsonData.contractorAttendanceId || ""
    }
}

export class ReqContractorAttendance {
    constructor({ companyId
        , contractorAttendanceId
        , contractorAttendanceSOPName   //作業名稱
        , customerContractId    //合約Id
        , startDate, endDate    //起迄
        , contractorAttendanceSOPStatus = CONTRACTOR_ATTENDANCE_STATUS_EDIT //作業狀態
        , info      //作業內容
        , creatId   //建立者Id
        , creatAt = moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
    }) {
        this.companyId = companyId
        this.contractorAttendanceId = contractorAttendanceId
        this.contractorAttendanceSOPName = contractorAttendanceSOPName
        this.customerContractId = customerContractId
        this.startDate = startDate
        this.endDate = endDate
        this.contractorAttendanceSOPStatus = contractorAttendanceSOPStatus
        this.info = new ReqContractorAttendanceInfo({})
        if(info !== undefined)
            this.info.fromJson(info)
        this.creatId = creatId
        this.creatAt = creatAt
    }

    fromJson(jsonData) {
        this.companyId = jsonData.companyId || ""
        this.contractorAttendanceId = jsonData.contractorAttendanceId || uuid(32, 64)
        this.contractorAttendanceSOPName = jsonData.contractorAttendanceSOPName || ""
        this.customerContractId = jsonData.customerContractId || ""
        this.startDate = jsonData.startDate || ""
        this.endDate = jsonData.endDate || ""
        this.dates = jsonData.dates || ""
        this.contractorAttendanceSOPStatus = jsonData.contractorAttendanceSOPStatus
        this.info = new ReqContractorAttendanceInfo({})
        this.info.fromJson(jsonData.info)

        this.creatId = jsonData.creatId
        this.creatAt = jsonData.creatAt
    }

    setData(creatName) {
        if (this.startDate) {
            const startDate = moment(this.startDate).format('YYYY/MM/DD')
            const endDate = moment(this.endDate).format('YYYY/MM/DD')
            this.dates = startDate + "～" + endDate
        }
        this.creatName = creatName || ""
    }
}

export class ReqContractorAttendanceInfo {
    constructor({ salaryMonthly, salaryHourly, bonus }) {
        this.salaryMonthly = salaryMonthly || new ContractorAttendanceInfo_SalaryMonthly({})
        this.salaryHourly = salaryHourly || new ContractorAttendanceInfo_SalaryHourly({})
        this.bonus = bonus || new ContractorAttendanceInfo_Bonus({})
    }
    fromJson(jsonData) {
        if (typeof jsonData === "string") {
            jsonData = JSON.parse(jsonData)
        }
        this.salaryMonthly = new ContractorAttendanceInfo_SalaryMonthly({})
        this.salaryHourly = new ContractorAttendanceInfo_SalaryHourly({})
        this.bonus = new ContractorAttendanceInfo_Bonus({})
        try {
            this.salaryMonthly.fromJson(jsonData.salaryMonthly)
            this.salaryHourly.fromJson(jsonData.salaryHourly)
            this.bonus.fromJson(jsonData.bonus)
        } catch (error) {

        }
    }
}

class ContractorAttendanceInfo_Base {
    constructor({
        Enrolment,           //人數
        Tax,               //營業稅
        Invoice,           //發票金額
        attachment,         //附件
        Status,              //登錄作業狀態
        CustomerPositionListItems,   //職缺內容列表
        InsuranceListItems, //保險內容列表      RespCustomerPositionInfo_Insurance
        RecruitmentList,   //上工名單列表
    }) {
        this.Enrolment = Enrolment || 0
        this.Tax = Tax || new ContractorAttendanceInfo_Item({})
        this.Invoice = Invoice || new ContractorAttendanceInfo_Item({})
        this.attachment = new RespResumeOtherAttachment({})
        this.Status = Status || CONTRACTOR_ATTENDANCE_STATUS_EDIT
        this.CustomerPositionListItems = CustomerPositionListItems || []
        this.InsuranceListItems = InsuranceListItems || []
        this.RecruitmentList = RecruitmentList || []
    }
    fromJson(jsonData) {
        this.Enrolment = jsonData.Enrolment || 0
        this.Tax = jsonData.Tax || new ContractorAttendanceInfo_Item({})
        this.Invoice = jsonData.Invoice || new ContractorAttendanceInfo_Item({})
        this.attachment = jsonData.attachment || new RespResumeOtherAttachment({})
        this.Status = jsonData.Status || CONTRACTOR_ATTENDANCE_STATUS_EDIT
        this.CustomerPositionListItems = jsonData.CustomerPositionListItems || []
        this.InsuranceListItems = jsonData.InsuranceListItems || {}
        this.RecruitmentList = jsonData.RecruitmentList || []
    }

    setInsuranceListItems(items) {
        this.InsuranceListItems = items
    }
}

/** 時薪與月薪繼承 Base */
class ContractorAttendanceInfo_BaseSalary extends ContractorAttendanceInfo_Base {
    constructor({
        Enrolment,           //人數
        Salary,            //應付薪資
        InsuranceCosts,    //廠商負擔保險費用
        InsuranceCostItem,  //保險費率
        ServiceFee,        //服務費
        Found,              //保險基金
        Tax,               //營業稅
        Invoice,           //發票金額
        Status,              //登錄作業狀態
        CustomerPositionListItems,   //職缺內容列表
        InsuranceListItems, //保險內容列表
        RecruitmentList,   //上工名單列表
    }) {
        super({ Enrolment, Tax, Invoice, Status, CustomerPositionListItems, InsuranceListItems, RecruitmentList })
        this.Salary = Salary || new ContractorAttendanceInfo_Item({})
        /** 廠商負擔保險費用 */
        this.InsuranceCosts = InsuranceCosts || new ContractorAttendanceInfo_Item({})
        this.InsuranceCostItem = InsuranceCostItem || new ReqInsuranceCostItem({})
        this.Found = Found || new ContractorAttendanceInfo_Item({})
        this.ServiceFee = ServiceFee || new ContractorAttendanceInfo_Item({})
    }
    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.Salary = jsonData.Salary || new ContractorAttendanceInfo_Item({})
        this.InsuranceCosts = jsonData.InsuranceCosts || new ContractorAttendanceInfo_Item({})
        var InsuranceCostItem = new ReqInsuranceCostItem({})
        InsuranceCostItem.fromJson(jsonData.InsuranceCostItem)
        this.Found = jsonData.Found || new ContractorAttendanceInfo_Item({})
        this.InsuranceCostItem = InsuranceCostItem
        this.ServiceFee = jsonData.ServiceFee || new ContractorAttendanceInfo_Item({})
    }


    setSalary({ Amount/*, Notice, Action*/, ActionTime }) {
        this.Salary = new ContractorAttendanceInfo_Item({
            Amount,
            // Notice,
            // Action,
            ActionTime
        })
    }

    setInsuranceCosts({Amount, ActionTime}){
        this.InsuranceCosts = new ContractorAttendanceInfo_Item({
            Amount,
            ActionTime
        })
    }

    setFound({Amount, ActionTime}){
        this.Found = new ContractorAttendanceInfo_Item({
            Amount,
            ActionTime
        })
    }


    setServiceFee({Amount, ActionTime}){
        this.ServiceFee = new ContractorAttendanceInfo_Item({
            Amount,
            ActionTime
        })
    }
}

/** 月薪 */
export class ContractorAttendanceInfo_SalaryMonthly extends ContractorAttendanceInfo_BaseSalary {
    constructor({
        Enrolment,           //人數
        BaseSalary,        //底薪
        Salary,            //應付薪資
        InsuranceCosts,    //保險費用
        Found,              //保險基金
        ServiceFee,        //服務費
        Tax,               //營業稅
        Invoice,           //發票金額
        Status,              //登錄作業狀態
        CustomerPositionListItems,   //職缺內容列表
        InsuranceListItems, //保險內容列表
        RecruitmentList,   //上工名單列表
        DailyWageMonthly,  //日薪計算方法
    }) {
        super({ Enrolment, Salary, InsuranceCosts, Found, ServiceFee, Tax, Invoice, Status, CustomerPositionListItems, InsuranceListItems, RecruitmentList })
        this.BaseSalary = BaseSalary || new ContractorAttendanceInfo_Item({})
        this.DailyWageMonthly = DailyWageMonthly || DailyWageMonthly_Fixed
    }
    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.BaseSalary = jsonData.BaseSalary || new ContractorAttendanceInfo_Item({})
        this.DailyWageMonthly = jsonData.DailyWageMonthly || DailyWageMonthly_Fixed
    }

    setBaseSalary({ Amount/*, Notice, Action*/, ActionTime }) {
        this.BaseSalary = new ContractorAttendanceInfo_Item({
            Amount,
            // Notice,
            // Action,
            ActionTime
        })
    }
}
//時薪
export class ContractorAttendanceInfo_SalaryHourly extends ContractorAttendanceInfo_BaseSalary {
    constructor({
        Enrolment,           //人數
        Pretax,             //請款金額
        Salary,            //應付薪資
        InsuranceCosts,    //保險費用
        Found,              //保險基金
        ServiceFee,        //服務費
        Tax,               //營業稅
        Invoice,           //發票金額
        Status,              //登錄作業狀態
        CustomerPositionListItems,   //職缺內容列表
        InsuranceListItems, //保險內容列表
        RecruitmentList,   //上工名單列表
    }) {
        super({ Enrolment, Salary, InsuranceCosts, Found, ServiceFee, Tax, Invoice, Status, CustomerPositionListItems, InsuranceListItems, RecruitmentList })
        this.Pretax = Pretax || new ContractorAttendanceInfo_Item({})
    }
    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.Pretax = jsonData.Pretax || new ContractorAttendanceInfo_Item({})
    }

    setPretax({ Amount/*, Notice, Action*/, ActionTime }) {
        this.Pretax = new ContractorAttendanceInfo_Item({
            Amount,
            // Notice,
            // Action,
            ActionTime
        })
    }
}
//代招
export class ContractorAttendanceInfo_Bonus extends ContractorAttendanceInfo_Base {
    constructor({
        Enrolment,          //人數
        Bonus,              //代招金額
        Tax,                //營業稅
        Invoice,             //發票金額
        Status,              //登錄作業狀態
        CustomerPositionListItems,   //職缺內容列表
        InsuranceListItems, //保險內容列表
        RecruitmentList,   //上工名單列表
    }) {
        super({ Enrolment, Tax, Invoice, Status, CustomerPositionListItems, InsuranceListItems, RecruitmentList })
        this.Bonus = Bonus || new ContractorAttendanceInfo_Item({})
    }
    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.Bonus = jsonData.Bonus || new ContractorAttendanceInfo_Item({})
    }
}

export class ContractorAttendanceInfo_Item {
    constructor({
        Amount,             //合計金額
        ActionTime,         //作業時間點
        // Action,             //作業
        // Notice              //提示
    }) {
        this.Amount = Amount || "N/A"
        this.ActionTime = ActionTime || "N/A"
        // this.Action = Action
        // this.Notice = Notice || ""
    }
    fromJson(jsonData) {
        this.Amount = jsonData.Amount || "N/A"
        this.ActionTime = jsonData.ActionTime || "N/A"
        // this.Action = jsonData.Action
        // this.Notice = jsonData.Notice || ""
    }
}

export class CustomerPositionListItem {
    constructor({
        creatAt,    //取得資料日期
        CustomerPositionDetail,
        Enrolment   //人數
    }) {
        this.creatAt = creatAt
        this.CustomerPositionDetail = CustomerPositionDetail || {}
        this.Enrolment = Enrolment || 0
    }
    fromJson(jsonData) {
        this.creatAt = jsonData.creatAt || ""
        this.CustomerPositionDetail = jsonData.CustomerPositionDetail || {}
        this.Enrolment = jsonData.Enrolment || 0
    }
}


export class ReqContractorAttendanceRecruitmentList extends ReqCustomerPositionList {
    constructor({ companyId, customerContractId, wageType, startDate, endDate }) {
        super({ customerContractId, wageType })
        this.companyId = companyId
        this.startDate = startDate
        this.endDate = endDate
    }

    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.companyId = jsonData.companyId || ""
        this.startDate = jsonData.startDate || ""
        this.endDate = jsonData.endDate || ""
    }
}

export class ReqContractorAttendanceRecruitmentContractor extends ReqContractorAttendanceRecruitmentList {
    constructor({ companyId, customerContractId, caseContractor, wageType, startDate, endDate }) {
        super({ companyId, customerContractId, wageType, startDate, endDate })
        this.caseContractor = caseContractor
    }

    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.caseContractor = jsonData.caseContractor || ""
    }
}

export class ContractorAttendanceListItem {
    constructor({
        caseContractor,                 //外派員工Id
        caseContractorName,             //外派員工姓名
        customerPositionId,             //職缺Id
        recruitmentContractorCaseInfo,  //案件資訊
        insurance                       //保險資訊
    }) {
        this.caseContractor = caseContractor || ""
        this.caseContractorName = caseContractorName || ""
        this.customerPositionId = customerPositionId
        this.recruitmentContractorCaseInfo = recruitmentContractorCaseInfo
        this.insurance = insurance
    }
    fromJson(jsonData) {
        this.caseContractor = jsonData.caseContractor || ""
        this.caseContractorName = jsonData.caseContractorName || ""
        this.customerPositionId = jsonData.customerPositionId || ""
        this.recruitmentContractorCaseInfo = jsonData.recruitmentContractorCaseInfo || ""
        this.insurance = jsonData.insurance || ""
    }
}


export class ReqInsuranceRecruitmentItem {
    constructor({
        caseContractor,
        Name,           //姓名
        Job,            //職務
        caseResignDate = "",    //離職日(下工日)
        AttendanceDay = 0,  //出勤天數
        Salary = 0,     //應付薪資
        LaborInsuranceLevelAmount = 0,   //勞保級距金額
        InsuranceBurdenType,    //公司負擔 or 廠商負擔
        LaborInsurance = 0,   //勞保
        LaborPension = 0,     //勞退
        HealthInsuranceLevelAmount = 0,   //勞保級距金額
        HealthInsurance = 0,  //健保
        GroupInsuranceBurdenType,           //團保 公司負擔 or 廠商負擔
        GroupInsurancePremium = 0,          //每人每日保費金額
        GroupInsurance = 0,   //團保
        PersonRate = 0,         //個人負擔
        AddInsuranceBurdenType = 0,     //健保補充保費
        PreServiceFee = 0,      //服務費-未扣保費
        ServiceFee = 0,        //服務費
    }) {
        this.caseContractor = caseContractor
        this.Name = Name
        this.Job = Job
        this.caseResignDate = caseResignDate
        this.AttendanceDay = AttendanceDay
        this.Salary = Salary
        this.LaborInsuranceLevelAmount = LaborInsuranceLevelAmount
        this.init()
        this.InsuranceBurdenType = InsuranceBurdenType
        // this.LaborInsurance = LaborInsurance
        this.LborPension = LaborPension
        this.HealthInsuranceLevelAmount = HealthInsuranceLevelAmount
        // this.HealthInsurance = HealthInsurance
        this.GroupInsuranceBurdenType = GroupInsuranceBurdenType
        this.GroupInsurancePremium = GroupInsurancePremium
        this.GroupInsurance = GroupInsurance
        this.PersonRate = PersonRate
        this.AddInsuranceBurdenType = AddInsuranceBurdenType
        this.PreServiceFee = PreServiceFee
        /** 服務費 */
        this.ServiceFee = ServiceFee
        /** 眷屬人數 */
        this.Family = 0
    }

    fromJson(jsonData) {
        this.caseContractor = jsonData.caseContractor
        this.Name = jsonData.Name
        this.Job = jsonData.Job
        this.caseResignDate = jsonData.caseResignDate
        this.AttendanceDay = jsonData.AttendanceDay
        this.Salary = jsonData.Salary
        this.LaborInsuranceLevelAmount = jsonData.LaborInsuranceLevelAmount
        this.init()
        this.InsuranceBurdenType = jsonData.InsuranceBurdenType
        // this.LaborInsurance = jsonData.LaborInsurance
        this.LaborPension = jsonData.LaborPension || 0
        this.HealthInsuranceLevelAmount = jsonData.HealthInsuranceLevelAmount
        // this.HealthInsurance = jsonData.HealthInsurance
        this.GroupInsuranceBurdenType = jsonData.GroupInsuranceBurdenType
        this.GroupInsurancePremium = jsonData.GroupInsurancePremium
        this.GroupInsurance = jsonData.GroupInsurance || 0
        this.PersonRate = jsonData.PersonRate
        this.AddInsuranceBurdenType = jsonData.AddInsuranceBurdenType
        this.PreServiceFee = jsonData.PreServiceFee || 0
        this.ServiceFee = jsonData.ServiceFee || 0
        this.Family = jsonData.Family || 0

        this.AccidentAmount = jsonData.AccidentAmount || 0
        this.EmploymentAmount = jsonData.EmploymentAmount || 0
        this.OccupationalAccidentAmount = jsonData.OccupationalAccidentAmount || 0
        this.WageArrearsPaymentFundAmount = jsonData.WageArrearsPaymentFundAmount || 0
        this.PersonLaborInsurance = jsonData.PersonLaborInsurance || 0
        this.UnitLaborInsurance = jsonData.UnitLaborInsurance || 0
        this.UnitHealthInsurance = jsonData.UnitHealthInsurance || 0
        this.PersonHealthInsurance = jsonData.PersonHealthInsurance || 0
        this.PersonPremiumAmount = jsonData.PersonPremiumAmount || 0
    }
    init() {
        this._InsuranceCoverageRatio = this.AttendanceDay / 30  //投保比率=
        this._RealLaborInsuranceLevelAmount = this.LaborInsuranceLevelAmount * this._InsuranceCoverageRatio     //調整後之投保金額=
    }
    setAmount(rateInfo) {
        console.log("ReqInsuranceRecruitmentItem setAmount")
        var InsuranceCostRate = new ReqInsuranceCostRate({})
        InsuranceCostRate.fromJson(rateInfo)
        /** 普通事故保費 */
        this.AccidentAmount = InsuranceCostRate.getAccidentRate() * this._RealLaborInsuranceLevelAmount 
        this.AccidentAmount = Math.round(this.AccidentAmount)
        /** 就業保險保費 */
        this.EmploymentAmount = InsuranceCostRate.getEmploymentRate() * this._RealLaborInsuranceLevelAmount
        this.EmploymentAmount = Math.round(this.EmploymentAmount)
        /** 職業災害保險保費 */
        this.OccupationalAccidentAmount = InsuranceCostRate.getOccupationalAccidentRate() * this._RealLaborInsuranceLevelAmount
        this.OccupationalAccidentAmount = Math.round(this.OccupationalAccidentAmount)
        /** 工資墊償基金提繳保費 */
        this.WageArrearsPaymentFundAmount = InsuranceCostRate.getWageArrearsPaymentFundRate() * this._RealLaborInsuranceLevelAmount
        this.WageArrearsPaymentFundAmount = Math.round(this.WageArrearsPaymentFundAmount)
        /** 勞保個人負擔 */
        this.PersonLaborInsurance = InsuranceCostRate.getPersonPremiumRate() * (this.AccidentAmount + this.EmploymentAmount)
        this.PersonLaborInsurance = Math.round(this.PersonLaborInsurance)
        /** 勞保單位負擔 */
        this.UnitLaborInsurance = InsuranceCostRate.getUnitPremiumRate() * (this.AccidentAmount + this.EmploymentAmount) + this.OccupationalAccidentAmount + this.WageArrearsPaymentFundAmount
        this.UnitLaborInsurance = Math.round(this.UnitLaborInsurance)
        /** 勞退  */
        this.LaborPension = InsuranceCostRate.getLaborPensionRate() * this._RealLaborInsuranceLevelAmount
        this.LaborPension = Math.round(this.LaborPension)

        /** 健保單位負擔  */
        this.UnitHealthInsurance = InsuranceCostRate.getUnitHealthRate() * InsuranceCostRate.getFamilyAVG() * InsuranceCostRate.getHealthRate() * this.HealthInsuranceLevelAmount
        this.UnitHealthInsurance = Math.round(this.UnitHealthInsurance)
        /** 健保員工負擔  */
        this.PersonHealthInsurance = InsuranceCostRate.getPersonHealthRate() * (1 + this.Family) * InsuranceCostRate.getHealthRate() * this.HealthInsuranceLevelAmount
        this.PersonHealthInsurance = Math.round(this.PersonHealthInsurance)

        if (this.caseResignDate !== "") {
            var diff = moment(this.caseResignDate).diff(moment(new Date()).endOf('month'), 'days')  //上班日與開始日差幾天
            console.log(diff)
            if (diff > 0) {
                this.UnitHealthInsurance = 0
                this.PersonHealthInsurance = 0
            }
        }
        /** 團保  */
        this.GroupInsurance = this.GroupInsurancePremium * this.AttendanceDay
        this.GroupInsurance = Math.round(this.GroupInsurance)
        /** 個人總負擔  */
        this.PersonPremiumAmount = this.PersonLaborInsurance + this.UnitHealthInsurance
        this.PersonPremiumAmount = Math.round(this.PersonPremiumAmount)

        if (this.InsuranceBurdenType === InsuranceBurdenType_Company) {
            /** 補充保費  */
            this.AddInsuranceBurdenType = (this.Salary - this.LaborInsuranceLevelAmount) * 0.0191
            if(this.AddInsuranceBurdenType < 0){
                this.AddInsuranceBurdenType = 0
            }
            this.AddInsuranceBurdenType = Math.round(this.AddInsuranceBurdenType)
            /** 服務費 */
            this.ServiceFee = this.PreServiceFee - this.UnitLaborInsurance - this.LaborPension - this.UnitHealthInsurance - this.AddInsuranceBurdenType - this.GroupInsurance
        } else {
            this.AddInsuranceBurdenType = 0
            this.ServiceFee = this.PreServiceFee
        }
    }
}

const DefaultAccidentRate = 10  //%
const DefaultEmploymentRate = 1 //%
const DefaultOccupationalAccidentRate = 0.21    //%
const DefaultWageArrearsPaymentFundRate = 0.025 //%
const DefaultLaborPensionRate = 6   //%
const DefaultHealthRate = 4.69  //%
const DefaultFamilyAVG = 1.58   //int
const DefaultCustomerSupplementaryPremium = 0   //int
const DefaultFoundRate = 5  //%

export class ReqInsuranceCostItem {
    constructor() {
        this.InsuranceCostRate = new ReqInsuranceCostRate({})
        this.InsuranceRecruitmentList = []
        this.InsuranceAmount = new ReqInsuranceAmount({})
        this.Status = CONTRACTOR_ATTENDANCE_STATUS_EDIT
    }
    fromJson(jsonData) {
        this.InsuranceCostRate = new ReqInsuranceCostRate({})
        if (jsonData.InsuranceCostRate !== undefined) {
            this.InsuranceCostRate.fromJson(jsonData.InsuranceCostRate)
        }
        this.InsuranceRecruitmentList = jsonData.InsuranceRecruitmentList || []
        this.InsuranceAmount = new ReqInsuranceAmount({})
        if (jsonData.InsuranceAmount !== undefined) {
            this.InsuranceAmount.fromJson(jsonData.InsuranceAmount)
        }
        this.Status = jsonData.Status || CONTRACTOR_ATTENDANCE_STATUS_EDIT
    }

    setInsuranceCostRate(InsuranceCostRate){
        this.InsuranceCostRate = InsuranceCostRate
    }

    setInsuranceRecruitmentList(list) {
        this.InsuranceRecruitmentList = list
    }
    setInsuranceAmount() {
        this.InsuranceAmount.setInsuranceAmount(this.InsuranceRecruitmentList, this.InsuranceCostRate.CustomerSupplementaryPremium, this.InsuranceCostRate.getFoundRate())
    }
}
export class ReqInsuranceCostRate {
    constructor({
        AccidentRate = DefaultAccidentRate,                                 //普通事故費率
        EmploymentRate = DefaultEmploymentRate,                             //就業保險費率
        OccupationalAccidentRate = DefaultOccupationalAccidentRate,        //職業災害保險費率
        WageArrearsPaymentFundRate = DefaultWageArrearsPaymentFundRate,    //工資墊償基金提繳費率
        LaborPensionRate = DefaultLaborPensionRate,                         //勞工退休基金費率
        HealthRate = DefaultHealthRate,                                     //健保費率
        FamilyAVG = DefaultFamilyAVG,                                       //本人及平均眷口數
        CustomerSupplementaryPremium = DefaultCustomerSupplementaryPremium,    //廠商負擔補充保費合計金額
        FoundRate = DefaultFoundRate,                                        //保險基金費率
    }) {
        this.init()
        this.AccidentRate = AccidentRate
        this.EmploymentRate = EmploymentRate
        this.OccupationalAccidentRate = OccupationalAccidentRate
        this.WageArrearsPaymentFundRate = WageArrearsPaymentFundRate
        this.LaborPensionRate = LaborPensionRate
        this.HealthRate = HealthRate
        this.FamilyAVG = FamilyAVG
        this.CustomerSupplementaryPremium = CustomerSupplementaryPremium
        this.FoundRate = FoundRate
    }
    fromJson(jsonData) {
        // console.log(jsonData)
        this.init()
        this.AccidentRate = jsonData.AccidentRate || DefaultAccidentRate
        this.EmploymentRate = jsonData.EmploymentRate || DefaultEmploymentRate
        this.OccupationalAccidentRate = jsonData.OccupationalAccidentRate || DefaultOccupationalAccidentRate
        this.WageArrearsPaymentFundRate = jsonData.WageArrearsPaymentFundRate || DefaultWageArrearsPaymentFundRate
        this.LaborPensionRate = jsonData.LaborPensionRate || DefaultLaborPensionRate
        this.HealthRate = jsonData.HealthRate || DefaultHealthRate
        this.FamilyAVG = jsonData.FamilyAVG || DefaultFamilyAVG
        this.CustomerSupplementaryPremium = jsonData.CustomerSupplementaryPremium || DefaultCustomerSupplementaryPremium
        this.FoundRate = jsonData.FoundRate || DefaultFoundRate
    }

    init() {
        this.PersonPremiumRate = 0.2     //普通事故保險及就業保險：個人負擔
        this.UnitPremiumRate = 0.7       //普通事故保險及就業保險：單位負擔
        this.GovPremiumRate = 0.1        //普通事故保險及就業保險：政府負擔
        this.PersonHealthRate = 0.3     //健康保險：個人負擔
        this.UnitHealthRate = 0.6       //健康保險：單位負擔
        this.GovHealthRate = 0.1        //健康保險：政府負擔
    }

    getAccidentRate() {
        return this.AccidentRate * 0.01
    }
    getEmploymentRate() {
        return this.EmploymentRate * 0.01
    }
    getOccupationalAccidentRate() {
        return this.OccupationalAccidentRate * 0.01
    }
    getWageArrearsPaymentFundRate() {
        return this.WageArrearsPaymentFundRate * 0.01
    }
    getLaborPensionRate() {
        return this.LaborPensionRate * 0.01
    }
    getHealthRate() {
        return this.HealthRate * 0.01
    }
    getFamilyAVG() {
        return this.FamilyAVG
    }
    getCustomerSupplementaryPremium() {
        return this.CustomerSupplementaryPremium
    }
    getFoundRate() {
        return this.FoundRate * 0.01
    }
    getPersonPremiumRate() {
        return this.PersonPremiumRate
    }
    getUnitPremiumRate() {
        return this.UnitPremiumRate
    }
    getGovPremiumRate() {
        return this.GovPremiumRate
    }
    getPersonHealthRate() {
        return this.PersonHealthRate
    }
    getUnitHealthRate() {
        return this.UnitHealthRate
    }
    getGovHealthRate() {
        return this.GovHealthRate
    }
}

export class ReqInsuranceAmount {
    constructor() {
        /** 個人負擔 */
        this.Person = new ReqInsuranceAmountItem({})
        /** 公司負擔 */
        this.Company = new ReqInsuranceAmountItem({})
        /** 廠商負擔 */
        this.Customer = new ReqInsuranceAmountItem({})
        /** */
        this.Found = new ReqInsuranceAmountItem({})
    }

    init() {
        this.Person = new ReqInsuranceAmountItem({})
        this.Company = new ReqInsuranceAmountItem({})
        this.Customer = new ReqInsuranceAmountItem({})
        this.Found = new ReqInsuranceAmountItem({})
    }

    fromJson(jsonData) {
        this.Person = new ReqInsuranceAmountItem({})
        this.Person.fromJson(jsonData.Person)
        this.Company = new ReqInsuranceAmountItem({})
        this.Person.fromJson(jsonData.Company)
        this.Customer = new ReqInsuranceAmountItem({})
        this.Person.fromJson(jsonData.Customer)
        this.Found = new ReqInsuranceAmountItem({})
        this.Found.fromJson(jsonData.Found)
    }
    setInsuranceAmount(list, CustomerSupplementaryPremium, FoundRate) {
        this.init()
        list.forEach((item, index) => {
            var mReqInsuranceRecruitmentItem = new ReqInsuranceRecruitmentItem({})
            mReqInsuranceRecruitmentItem.fromJson(item)
            if (mReqInsuranceRecruitmentItem.InsuranceBurdenType === InsuranceBurdenType_Company) {
                this.Company.LaborInsurance += mReqInsuranceRecruitmentItem.UnitLaborInsurance
                this.Company.LaborPension += mReqInsuranceRecruitmentItem.LaborPension
                this.Company.HealthInsurance += mReqInsuranceRecruitmentItem.UnitHealthInsurance
                // this.Customer.LaborInsurance = ""
            } else {
                this.Customer.LaborInsurance += mReqInsuranceRecruitmentItem.UnitLaborInsurance
                this.Customer.LaborPension += mReqInsuranceRecruitmentItem.LaborPension
                this.Customer.HealthInsurance += mReqInsuranceRecruitmentItem.UnitHealthInsurance
                // this.Company.LaborInsurance = ""
            }
            if (mReqInsuranceRecruitmentItem.GroupInsuranceBurdenType === InsuranceBurdenType_Company) {
                this.Company.GroupInsurance += mReqInsuranceRecruitmentItem.GroupInsurance
            }else{
                this.Customer.GroupInsurance += mReqInsuranceRecruitmentItem.GroupInsurance
            }
            this.Person.LaborInsurance += mReqInsuranceRecruitmentItem.PersonLaborInsurance
            this.Person.HealthInsurance += mReqInsuranceRecruitmentItem.PersonHealthInsurance
            this.Person.PersonPremium += mReqInsuranceRecruitmentItem.PersonPremiumAmount
            this.Company.AddInsuranceBurdenType += mReqInsuranceRecruitmentItem.AddInsuranceBurdenType
            this.Company.ServiceFee += mReqInsuranceRecruitmentItem.ServiceFee
        })
        this.Customer.AddInsuranceBurdenType = CustomerSupplementaryPremium
        this.Found.ServiceFee = this.Company.ServiceFee * FoundRate
        this.Found.ServiceFee = Math.round(this.Found.ServiceFee)
        this.Person.setAmount()
        this.Company.setAmount()
        this.Customer.setAmount()
        this.Found.setAmount()
    }
}

class ReqInsuranceAmountItem {
    constructor() {
        /** 總金額 */
        this.Amount = 0
        /** 勞保 */
        this.LaborInsurance = 0
        /** 勞退 */
        this.LaborPension = 0
        /** 健保 */
        this.HealthInsurance = 0
        /** 團保 */
        this.GroupInsurance = 0
        /** 個人負擔 */
        this.PersonPremium = 0
        /** 補充保費 */
        this.AddInsuranceBurdenType = 0
        /** 服務費 */
        this.ServiceFee = 0
    }
    fromJson(jsonData) {
        this.Amount = jsonData.Amount || 0
        this.LaborInsurance = jsonData.LaborInsurance || 0
        this.LaborPension = jsonData.LaborPension || 0
        this.HealthInsurance = jsonData.HealthInsurance || 0
        this.GroupInsurance = jsonData.GroupInsurance || 0
        this.PersonPremium = jsonData.PersonPremium || 0
        this.AddInsuranceBurdenType = jsonData.AddInsuranceBurdenType || 0
        this.ServiceFee = jsonData.ServiceFee || 0
    }

    setAmount() {
        this.Amount = this.LaborInsurance + this.LaborPension + this.HealthInsurance + this.GroupInsurance
            + this.PersonPremium + this.AddInsuranceBurdenType + this.ServiceFee
    }
}

// export class ReqRecruitmentItem_SalaryBase {
//     /*

//         Name,           //姓名
//         Job,            //職務
//         BaseSalary,     //底薪
//         AttendanceDay,  //出勤天數
//         OvertimePay,    //加班
//         AbsenceAmout,   //請假
//         SalaryAddAmount,    //加項
//         SalarySubtractAmount,   //減項
//         Salary,         //應付薪資
//         PreServiceFee,  //服務費-未扣保費
//     */
//     constructor({ Recruitment, caseInfo, PositionInfo, startDate, endDate }) {
//         this.Recruitment = Recruitment
//         this.caseInfo = caseInfo
//         this.PositionInfo = PositionInfo
//         this.startDate = startDate
//         this.endDate = endDate
//         this.dates = startDate + "～" + endDate
//         if (Recruitment !== undefined) {
//             this.customerPositionId = Recruitment.customerPositionId || ""  //職缺Id
//             this.caseContractor = Recruitment.caseContractor || ""          //外派員工Id
//             this.Name = Recruitment.caseContractorName || ""                //姓名
//         }
//         if (PositionInfo !== undefined) {
//             this.Job = PositionInfo.job || ""                               //職務
//             this.BaseSalary = parseInt(PositionInfo.wageInfo.MonthlySalary) || 0      //底薪
//         }
//     }
// }

// export class ReqRecruitmentItem_SalaryHourly extends ReqRecruitmentItem_SalaryBase {
//     constructor({ Recruitment, caseInfo, PositionInfo, startDate, endDate }) {
//         super({ Recruitment, caseInfo, PositionInfo, startDate, endDate })
//     }
// }
// export class ReqRecruitmentItem_SalaryMonthly {
//     /*

//         Name,           //姓名
//         Job,            //職務
//         BaseSalary,     //底薪
//         AttendanceDay,  //出勤天數
//         OvertimePay,    //加班
//         AbsenceAmout,   //請假
//         SalaryAddAmount,    //加項
//         SalarySubtractAmount,   //減項
//         Salary,         //應付薪資
//         PreServiceFee,  //服務費-未扣保費
//     */
//     constructor({ Recruitment, caseInfo, PositionInfo, startDate, endDate }) {
//         if(Recruitment === undefined)
//             return
//         console.log(Recruitment)
//         // console.log(caseInfo)
//         // console.log(PositionInfo)
//         this.Recruitment = Recruitment
//         this.caseInfo = caseInfo
//         this.PositionInfo = PositionInfo
//         this.startDate = startDate
//         this.endDate = endDate
//         this.dates = startDate + "～" + endDate
//         if (Recruitment !== undefined) {
//             this.customerPositionId = Recruitment.customerPositionId || ""  //職缺Id
//             this.caseContractor = Recruitment.caseContractor || ""          //外派員工Id
//             this.Name = Recruitment.caseContractorName || ""                //姓名
//         }
//         if (PositionInfo !== undefined) {
//             this.Job = PositionInfo.job || ""                               //職務
//             this.BaseSalary = parseInt(PositionInfo.wageInfo.MonthlySalary) || 0      //底薪
//         }
//         this.AttendanceDay = 0                                          //出勤天數
//         this.OvertimePay = 0                                            //加班
//         this.AbsenceItems = []                                          //請假項目
//         this.AbsenceAmout = 0                                          //請假金額
//         this.initAbsenceItems()
//         this.SalaryAddItems = []                                        //加項項目
//         this.SalaryAddAmount = 0                                        //加項金額
//         this.initSalaryAddItems()
//         this.SalarySubtractItems = []                                   //減項項目
//         this.SalarySubtractAmount = 0                                   //減項金額
//         this.initSalarySubtractItems()
//         this.setDate()
//         console.log(this.BaseSalary)
//         this.setDailyWageMonthly(DailyWageMonthly_Fixed)
//         this.Salary = 0                                                 //應付薪資
//         this.PreServiceFee = 0                                          //服務費-未扣保費
//         this.setSalary()
//     }

//     fromJson(jsonData) {
//         this.Recruitment = jsonData.Recruitment
//         this.caseInfo = jsonData.caseInfo
//         this.PositionInfo = jsonData.PositionInfo
//         this.startDate = jsonData.startDate
//         this.endDate = jsonData.endDate
//         this.dates = jsonData.dates
//         this.customerPositionId = jsonData.Recruitment.customerPositionId || ""  //職缺Id
//         this.caseContractor = jsonData.Recruitment.caseContractor || ""          //外派員工Id
//         this.Name = jsonData.Recruitment.caseContractorName || ""                //姓名
//         this.Job = jsonData.PositionInfo.job || ""                               //職務
//         console.log(jsonData.PositionInfo.wageInfo)
//         this.BaseSalary = parseInt(jsonData.PositionInfo.wageInfo.MonthlySalary) || 0      //底薪
//         console.log(this.BaseSalary)
//         this.AttendanceDay = jsonData.AttendanceDay                                          //出勤天數
//         this.OvertimePay = jsonData.OvertimePay                                            //加班
//         this.AbsenceItems = jsonData.AbsenceItems                                          //請假項目
//         this.AbsenceAmout = jsonData.AbsenceAmout                                          //請假金額
//         this.SalaryAddItems = jsonData.SalaryAddItems                                        //加項項目
//         this.SalaryAddAmount = jsonData.SalaryAddAmount                                        //加項金額
//         this.SalarySubtractItems = jsonData.SalarySubtractItems                                   //減項項目
//         this.SalarySubtractAmount = jsonData.SalarySubtractAmount                                   //減項金額
//         this.setDate()
//         this.Salary = jsonData.Salary                                                 //應付薪資
//         this.PreServiceFee = jsonData.PreServiceFee                                          //服務費-未扣保費
//         this.hourlySalary = jsonData.hourlySalary
//         this.MonthlySalary = jsonData.MonthlySalary
//         // this.setSalary()
//     }

//     //設定加班金額
//     setOvertimePay(OvertimePay) {
//         console.log(OvertimePay)
//         this.OvertimePay = OvertimePay
//     }
//     //設定請假金額
//     setAbsenceAmout(AbsenceAmout) {
//         this.AbsenceAmout = AbsenceAmout
//     }

//     //請假初始化
//     initAbsenceItems() {
//         this.AbsenceItems.push(new ReqAbsenceItem({ key: 'SpecialLeave', name: "特休", proportions: 0, hours: 0, amount: 0 }))
//         this.AbsenceItems.push(new ReqAbsenceItem({ key: 'SickLeave', name: "病假", proportions: 0.5, hours: 0, amount: 0 }))
//         this.AbsenceItems.push(new ReqAbsenceItem({ key: 'CrampLeave', name: "生理假", proportions: 0.5, hours: 0, amount: 0 }))
//         this.AbsenceItems.push(new ReqAbsenceItem({ key: 'AbsenceLeave', name: "事假", proportions: 1, hours: 0, amount: 0 }))
//         this.AbsenceItems.push(new ReqAbsenceItem({ key: 'OtherAmount', name: "其他假", amount: 0 }))
//     }

//     //請假總計
//     setAbsenceItems(AbsenceItems) {
//         this.AbsenceItems = AbsenceItems
//         var AbsenceAmout = 0
//         AbsenceItems.map(item => (
//             // AbsenceAmout += this.hourlySalary * item.proportions * item.hours
//             AbsenceAmout += item.amount
//         ))
//         this.AbsenceAmout = AbsenceAmout
//     }

//     //加項初始化 
//     initSalaryAddItems() {
//         if (this.PositionInfo === undefined)
//             return
//         this.PositionInfo.wageInfo.SalaryAddItem.map((item) => (
//             this.SalaryAddItems.push(new ReqSalaryItem({ key: item.id, name: item.text }))
//         ))
//     }
//     //加項總計
//     setSalaryAddItems(SalaryAddItems) {
//         this.SalaryAddItems = SalaryAddItems
//         var amount = 0
//         SalaryAddItems.map(item => (
//             amount += item.amount
//         ))
//         this.SalaryAddAmount = amount
//     }

//     //減項初始化
//     initSalarySubtractItems() {
//         if (this.PositionInfo === undefined)
//             return
//         this.PositionInfo.wageInfo.SalarySubtractItem.map((item) => (
//             this.SalarySubtractItems.push(new ReqSalaryItem({ key: item.id, name: item.text }))
//         ))
//     }
//     //減項總計
//     setSalarySubtractItems(SalarySubtractItems) {
//         this.SalarySubtractItems = SalarySubtractItems
//         var amount = 0
//         SalarySubtractItems.map(item => (
//             amount += item.amount
//         ))
//         this.SalarySubtractAmount = amount
//     }

//     //計算應付
//     setSalary() {
//         console.log(this.OvertimePay)
//         this.Salary = this.MonthlySalary + this.OvertimePay - this.AbsenceAmout + this.SalaryAddAmount - this.SalarySubtractAmount
//         console.log(this.PositionInfo)
//         if (this.PositionInfo === undefined)
//             return
//         var MonthlySalaryAmount = this.PositionInfo.wageInfo.MonthlySalaryAmount
//         switch (parseInt(this.PositionInfo.wageInfo.MarginCalculationType)) {
//             case MarginCalculationType_Fixed:
//                 MonthlySalaryAmount = this.PositionInfo.wageInfo.MonthlySalaryAmount
//                 this.PreServiceFee = MonthlySalaryAmount * this.AttendanceRatio
//                 break;
//             case MarginCalculationType_BaseSalaryRatio:
//                 MonthlySalaryAmount = this.PositionInfo.wageInfo.MonthlySalaryAmount / 100
//                 this.PreServiceFee = Math.round(this.BaseSalary * MonthlySalaryAmount * this.AttendanceRatio)
//                 break;
//             case MarginCalculationType_RealPayRatio:
//                 MonthlySalaryAmount = this.PositionInfo.wageInfo.MonthlySalaryAmount / 100
//                 this.PreServiceFee = Math.round(this.Salary * MonthlySalaryAmount)
//                 break;
//             default:
//                 break;
//         }
//     }

//     setDate() {
//         if (this.caseInfo === undefined)
//             return
//         // console.log(moment(this.startDate))
//         // console.log(moment(this.caseInfo.caseOnBoardDate))  
//         var startDiff = moment(this.startDate).diff(moment(this.caseInfo.caseOnBoardDate), 'days')  //上班日與開始日差幾天
//         // console.log(startDiff)
//         if (startDiff <= 0) {
//             // this.sDay = moment(this.startDate).format('YYYY/MM/DD')     //實際開始日
//             this.sDay = moment(this.caseInfo.caseOnBoardDate).format('YYYY/MM/DD')  //實際開始日
//         } else {
//             this.sDay = moment(this.startDate).format('YYYY/MM/DD')
//         }
//         // console.log(this.sDay)
//         if (this.caseInfo.caseResignDate === "") {
//             this.eDay = moment(this.endDate).format('YYYY/MM/DD')       //實際結束日
//         } else {
//             this.eDay = moment(this.caseInfo.caseResignDate).format('YYYY/MM/DD')   //實際結束日
//         }
//         this.AttendanceDay = moment(this.eDay).diff(moment(this.sDay), 'days') + 1  //出勤天數
//     }

//     setDailyWageMonthly(DailyWageMonthly) {
//         // console.log(DailyWageMonthly)
//         switch (DailyWageMonthly) {
//             case DailyWageMonthly_Real:
//                 // console.log(this.sDay)
//                 // console.log(moment(this.sDay).daysInMonth())
//                 this.DailyWageMonthly = moment(this.sDay).daysInMonth();
//                 break;
//             default:
//                 this.DailyWageMonthly = 30
//                 break;
//         }
//         // console.log(this.DailyWageMonthly)
//         this.hourlySalary = this.BaseSalary / this.DailyWageMonthly / 8  //時薪
//         this.AttendanceRatio = 1
//         if (this.AttendanceDay < this.DailyWageMonthly) {
//             this.AttendanceRatio = this.AttendanceDay / this.DailyWageMonthly   //出勤比率
//         }

//         console.log(this.AttendanceRatio)
//         console.log(this.BaseSalary)
//         this.MonthlySalary = Math.round(this.BaseSalary * this.AttendanceRatio) //窴際月薪
//         console.log(this.MonthlySalary)
//         this.setSalary()
//     }
// }

// //加減項項目
// export class ReqSalaryItem {
//     constructor({ key, name, amount = 0 }) {
//         this.key = key
//         this.name = name
//         this.amount = amount
//     }
//     fromJson(jsonData) {
//         this.key = jsonData.key
//         this.name = jsonData.name
//         this.amount = jsonData.amount
//     }
//     setAmount(amount) {
//         this.amount = amount
//     }
// }

// //請假項目
// export class ReqAbsenceItem {
//     constructor({ key, name, proportions, hours = 0, amount = 0 }) {
//         this.key = key
//         this.name = name
//         this.proportions = proportions  //比例
//         this.hours = hours              //小時
//         this.amount = amount            //金額
//         this.hourlySalary = 0           //時薪  
//     }
//     setHourlySalary(hourlySalary) {
//         this.hourlySalary = hourlySalary      //時薪
//     }
//     setAmount({ hours, amount }) {
//         this.hours = hours
//         if (amount === undefined) {
//             var h = Math.round(parseFloat(hours) * this.proportions * parseFloat(this.hourlySalary))
//             if (!isNaN(h)) {
//                 this.amount = h             //總計
//             }
//         } else {
//             this.amount = parseInt(amount)
//         }
//     }
//     fromJson(jsonData) {
//         this.key = jsonData.key
//         this.name = jsonData.name
//         this.proportions = jsonData.proportions  //比例
//         this.hours = jsonData.hours || 0              //小時
//         this.amount = jsonData.amount || 0         //金額
//         this.hourlySalary = jsonData.hourlySalary || 0  //時薪
//     }
// }